import { KENO_NUMBER_STATUS, KenoNumber } from '@Animation/mechanics/base/number'
import { STANDARD_LARGE_NUMBER_RATIO } from '@Animation/constants'
import { ANIMATION_IDENTIFIERS } from '@Animation/types'
import { PLUS_3_ANIMATION_ATLAS_FRAMES, PLUS_3_TEXTURE_KEYS } from './constants'

export class Plus3Number extends KenoNumber {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    number: number,
    isPlayerSelected: boolean,
    animationIdentifier: ANIMATION_IDENTIFIERS,
  ) {
    super(scene, x, y, number, isPlayerSelected, animationIdentifier)
  }

  getGlowAtlasFrame() {
    return `${PLUS_3_ANIMATION_ATLAS_FRAMES.NUMBER_GLOW}`
  }

  getGlowAtlas() {
    return `${PLUS_3_TEXTURE_KEYS.ANIMATION_ATLAS}${this.animationIdentifier}`
  }

  createStatusTextureMap(): { [key in KENO_NUMBER_STATUS]: string } {
    return {
      [KENO_NUMBER_STATUS.DEFAULT]: `${PLUS_3_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED}${this.animationIdentifier}`,
      [KENO_NUMBER_STATUS.SELECTED_PLAYER]: `${PLUS_3_TEXTURE_KEYS.NUMBER_HIT}${this.animationIdentifier}`,
      [KENO_NUMBER_STATUS.SELECTED_SYSTEM]: `${PLUS_3_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED}${this.animationIdentifier}`,
      [KENO_NUMBER_STATUS.SELECTED_HIT]: `${PLUS_3_TEXTURE_KEYS.NUMBER_HIT}${this.animationIdentifier}`,
    }
  }

  async transitionToSystemSelected(): Promise<void> {
    await this.popNumberTexture(
      `${PLUS_3_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED_TRANSITION}${this.animationIdentifier}`,
      STANDARD_LARGE_NUMBER_RATIO,
      1,
    )
    super.transitionToSystemSelected()
  }

  async transitionToSelectedHit() {
    await this.popNumberTexture(
      `${PLUS_3_TEXTURE_KEYS.NUMBER_HIT_TRANSITION}${this.animationIdentifier}`,
      STANDARD_LARGE_NUMBER_RATIO,
      1,
    )
    super.transitionToSelectedHit()
  }

  async skip() {
    await super.skip()
    this.tempNumber?.destroy()
  }
}
